// 兼容IE11浏览器碎片
import "whatwg-fetch";
import "custom-event-polyfill";
import "core-js/stable/promise";
import "core-js/stable/symbol";
import "core-js/stable/string/starts-with";
import "core-js/web/url";

import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "@/store";
import Element from "element-ui";
import "@/utils/itrus.js";
import emitter from "@/mixins/emitter.js";
import * as resultObj from "./utils";
import "@/permission";

import "@/styles/element-variables.scss";
import "@/styles/common.scss";

Vue.config.productionTip = false;
Vue.use(Element);
Vue.mixin(emitter);
// 挂在公共方法
Object.keys(resultObj).forEach((key) => {
  Vue.prototype["$" + key] = resultObj[key];
});
// vue原型添加属性、方法
Vue.prototype.$env = process.env.PROJECT_ENV; // web表示saas平台，front表示前置
Vue.prototype.$builtMountApp = "builtsubview"; // 内置子应用容器名
Vue.prototype.$serviceMountApp = "subview"; // 内置子应用容器名

/* eslint-disable no-new */
new Vue({
  el: "#root-app",
  router,
  store,
  watch: {
    "$store.getters.subappClassName": function (n, o) {
      // 监听是否进入子应用
      if (n) {
        this.$nextTick(() => {
          document.body.className = n;
        });
      } else {
        this.$nextTick(() => {
          document.body.className = "";
        });
      }
    }
  },
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js